/* @flow */

import React from 'react'
import styled from 'styled-components'
import debounce from 'lodash/debounce'

const AddToCartV2QuickBuy = ({
  noPrice,
  totalQuantityInCart,
  cartIsSaving,
  onCartChange,
}) => {
  const [quantity, setQuantity] = React.useState(totalQuantityInCart)
  const [isDirty, setIsDirty] = React.useState(false)

  const changeVariantQuantity = React.useCallback(quantity => {
    onCartChange(quantity).then(() => {
      setIsDirty(false)
    })
  }, [])
  const debouncedChangeVariantQuantity = React.useCallback(
    debounce(changeVariantQuantity, 500),
    [changeVariantQuantity]
  )

  // When cart rows are loading, the total quantity prop can be initially 0 and we want
  // to update the displayed quantity when the loading is done
  React.useEffect(() => {
    if (!isDirty) {
      setQuantity(totalQuantityInCart)
    }
  }, [totalQuantityInCart])

  const onChange = change => {
    if (noPrice) {
      return
    }

    const newQuantity = quantity + change

    if (newQuantity < 0) {
      return
    }

    setIsDirty(true)
    setQuantity(newQuantity)
    debouncedChangeVariantQuantity(newQuantity)
  }

  return (
    <OneVariantContainer hasPrice={!noPrice}>
      {cartIsSaving ? (
        <span className="fa fa-spinner fa-spin splash-spinner" />
      ) : (
        <>
          <OneVariantAction onClick={() => onChange(-1)}>-</OneVariantAction>
          <OneVariantQuantity>{quantity}</OneVariantQuantity>
          <OneVariantAction onClick={() => onChange(1)}>+</OneVariantAction>
        </>
      )}
    </OneVariantContainer>
  )
}

const OneVariantContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  opacity: ${props => (props.hasPrice ? 1 : 0.2)};
  cursor: ${props => (props.hasPrice ? 'pointer' : 'default')};
`

const OneVariantQuantity = styled.div`
  font-size: 14px;
  width: 20px;
`

const OneVariantAction = styled.div`
  cursor: pointer;
  font-size: 22px;
  width: 30px;
  user-select: none;
`

export default AddToCartV2QuickBuy
